<template>
    <div class="dashboard">
        <div v-if="!loading">
            <!-- modal create job -->
            <Modal :config="jobModalConfig" @accept="createJob()">
                <template slot="header">
                    Opret nyt job
                </template>
                <template slot="content">
                    <div class="form grid-x">
                        <div v-for="jobtype in selectedRegnskab.jobType" :key="jobtype.kode" @click="setActiveJobType(jobtype.kode, jobtype.valid)" :class="{'selected': jobtype.kode === activeJobType, 'form-item-disabled': jobtype.valid !== 1}" class="form-item auto cell">
                            <div class="flex-center">
                                <p>{{jobtype.beskrivelse}}</p>
                            </div>
                            <div v-if="jobtype.kode === activeJobType" class="checkmark-checked">
                                <icon class="medium-svg fill-white" name="aktiveret"></icon>
                            </div>
                            <p class="form-item-warning" v-if="jobtype.valid !== 1">{{jobtype.validReason}}</p>
                        </div>
                    </div>
                </template>
            </Modal>

            <!-- modal create project -->
            <Modal :config="projectModalConfig" @accept="createProject()">
                <template slot="header">
                    Opret nyt projekt
                </template>
                <template slot="content">
                    <!-- projekt nummer -->
                    <div class="form">
                        <div class="grid-x align-items">
                            <div class="large-1 medium-1 small-2 cell flexbox-center">
                                <icon class="info small-svg" name="info"></icon>
                            </div>
                            <div class="auto cell border-bottom">
                                <div class="grid-x">
                                    <div class="large-3 medium-3 small-5 cell flexbox-center-left">
                                        <label for="remark">Projektnummer <span class="required">*</span></label>
                                    </div>
                                    <div class="auto cell">
                                        <input type="text" name="Projektnummer" title="projektnummer" v-model="newProject.projectNr">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- projekt navn -->
                    <div class="form">
                        <div class="grid-x align-items">
                            <div class="large-1 medium-1 small-2 cell flexbox-center">
                                <icon class="info small-svg" name="info"></icon>
                            </div>
                            <div class="auto cell border-bottom">
                                <div class="grid-x">
                                    <div class="large-3 medium-3 small-5 cell flexbox-center-left">
                                        <label for="remark">Navn</label>
                                    </div>
                                    <div class="auto cell">
                                        <input type="text" name="Navn" title="Navn" v-model="newProject.navn">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- projekt værdi -->
                    <div class="form">
                        <div class="grid-x align-items">
                            <div class="large-1 medium-1 small-2 cell flexbox-center">
                                <icon class="info small-svg" name="dollar"></icon>
                            </div>
                            <div class="auto cell border-bottom">
                                <div class="grid-x">
                                    <div class="large-3 medium-3 small-5 cell flexbox-center-left">
                                        <label for="remark">Værdi</label>
                                    </div>
                                    <div class="auto cell">
                                        <input type="text" name="Værdi" title="Værdi" v-model="newProject.projectVaerdi">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- projekt bemærkning -->
                    <div class="form">
                        <div class="grid-x align-items">
                            <div class="large-1 medium-1 small-2 cell flexbox-center">
                                <icon class="info small-svg" name="info"></icon>
                            </div>
                            <div class="auto cell border-bottom">
                                <div class="grid-x">
                                    <div class="large-3 medium-3 small-5 cell flexbox-center-left">
                                        <label for="remark">Bemærkning</label>
                                    </div>
                                    <div class="auto cell">
                                        <input type="text" name="Bemærkning" title="Bemærkning" v-model="newProject.beskrivelse">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </Modal>

            <Modal :config="importProjectModalConfig" @accept="importAssetProject()">
                <template slot="header">
                    Importér Asset projekt
                </template>
                <template slot="content">
                <p class="text-center">Dette kan tage noget tid.</p> 
                </template>
            </Modal>

            <!-- modal handler -->
            <Modal :config="handlerModalConfig">
                <template slot="header">
                    {{handlerHeader}}
                </template>
            </Modal>

            <div class="dashboard-hero-img"></div>

            <!-- dashboard header -->
            <div class="dashboard-header">
                <div class="grid-x">
                    <div class="large-2 dashboard-header-title large-offset-1 cell">
                        <h1>Spildevand</h1>
                    </div>
                    <div class="large-6 cell">

                        <!-- kpi filter -->
                        <div class="grid-x kpi" style="height: 129px;">
                            <!-- <div class="large-4 cell flexbox-center flex-column" v-for="kpi in KPIList" :key="kpi.filter">
                                <div class="flexbox-center flex-column kpi-section" :class="{'kpi-section-active': kpi.selected}" @click="showKpiData(kpi.filter, kpi.category)">
                                    <animated-number v-if="kpi.category === 'projects'" :number="kpi.count"></animated-number>
                                </div>
                                <span v-if="kpi.filter === 'onGoing'" class="kpi-section-title">
                                    Igangværende projekt<span v-if="kpi.count < 1 || kpi.count > 1">er</span>
                                </span>
                                <span v-if="kpi.filter === 'correction'" class="kpi-section-title">
                                    Berigtigelsesprojekt<span v-if="kpi.count < 1 || kpi.count > 1">er</span>
                                </span>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="grid-x dashboard-tabs-container">
                    <div class="large-7 large-offset-1 cell dashboard-tabs">
                        <a v-for="(item, index) in tabs" :key="index" :class="{'active': filters.selectedTab === item.name}" @click="changeWorkView(item.name)" class="hide-for-small-only">
                            <icon class="small-svg fill-white" :name="item.name"></icon>
                            <span>{{item.name | translateToDanish}}</span>
                        </a>
                    </div>
                    <div class="large-3 large-offset-2 flexbox-end cell dashboard-search-asset">
                        <router-link :to="{name: 'searchAsset'}">
                            <a class="button button-primary-test">
                                <icon class="small-svg fill-white" name="maplocation"></icon>
                                Find aktiv
                            </a>
                        </router-link>
                    </div>
                </div>
            </div>

            <!-- dashboard filtering -->
            <div class="grid-x dashboard-filter">
                <div class="large-10 large-offset-2 cell">
                    <div class="grid-x">
                        <div v-if="filters.selectedTab === 'projects'" class="large-3 small-12 cell flexbox-align-items dashboard-filter-search">
                            <input ref="input" class="form-control" type="text" v-model="searchString" placeholder="Søg efter projekt..." autofocus
                                @keydown.enter = 'enter'
                                @input='searchInput'
                            />
                        </div>
                        <div v-if="filters.selectedTab === 'projects'" class="large-5 small-12 cell flexbox-align-items">
                            <div v-for="status in filteredProjectStatus" :key="status.kode" @click="setProjectStatusCodes(status.kode)" class="filter-status">
                                <div class="flexbox-center filter-status-check" :class="{'active': filters.projectStatusCodes.indexOf(status.kode) > -1}" >
                                    <icon class="small-svg fill-white" :name="getProjectStatusIcon(status.beskrivelse)"></icon>
                                </div>
                                <span>{{status.beskrivelse | shortenStatusDescription}}</span>
                            </div>
                        </div>
                        <div v-if="filters.selectedTab === 'reports'" class="large-3 small-12 cell flexbox-align-items">
                            <span>Balance:</span>
                            <select v-model="selectedReportBalance" id="select-template" @change="changeBalanceType($event)">
                                <option value="" disabled="disabled">Vælg balance i listen</option>
                                <option v-for="balanceType in reportBalanceList" :selected="balanceType.beskrivelse" v-bind:key="balanceType.id" :value="balanceType.id">
                                    {{balanceType.beskrivelse}}
                                </option>
                            </select>
                        </div>
                        <div v-if="filters.selectedTab === 'reports'" class="large-3 small-12 cell flexbox-align-items">
                            <span>Årstal:</span>
                            <select v-model="yearSelected" class="small" @change="selectYear($event)">
                                <option v-for="year in years" :selected="year" :key="year.id" :value="year.id">
                                    {{year.aar}}
                                </option>
                            </select>
                        </div>
                        <div v-if="filters.selectedTab === 'asset'" class="large-3 small-12 cell flexbox-align-items filter-closed checkbox-end" style="cursor: inherit">
                            <span>Vis også afsluttede:</span>
                            <div :class="{'active': finishedAsset}" class="flexbox-center" @click="setFinishedAsset()" style="cursor: pointer;">
                                <icon v-show="finishedAsset" class="small-svg fill-white" name="checkmark"></icon>
                            </div>
                        </div>
                        <div v-if="filters.selectedTab === 'asset'" class="large-3 small-12 cell flexbox-align-items" style="cursor: inherit">
                            <span style="min-width: 95px">Afskriv dato:</span>
                            <date-picker
                                v-model="AfskrivningsDato"    
                                id="datepicker"
                                name="Datepicker"
                                language="da"
                                :monday-first="true"
                                full-month-name
                                class="full-width datepicker-filter"
                                format="d. MMMM yyyy"
                                placeholder="Vælg dato">
                                <icon class="calendar small-svg" name="calendar"></icon>
                            </date-picker>
                            <a class="button button-primary" @click="handleDepreciation()">Afskriv</a>
                        </div>
                    </div>
                </div>
            </div>

            <main>
                <div class="dashboard-content">
                    <div class="grid-x">
                        <div class="large-2 cell">

                            <!-- New work -->
                            <div class="new-work-container">
                                <a title="Opret nyt projekt" @click="createNewProject()" v-show="filters.selectedTab === 'projects' && getRegnskabSystemKode()" class="button button-round flexbox-center no-label">
                                    <icon class="large-svg fill-primary" name="projects-new"></icon>
                                </a>
                                <a title="Opret nyt job" @click="newJobModal()" v-show="filters.selectedTab === 'jobs'" class="button button-round flexbox-center no-label">
                                    <icon class="large-svg fill-primary" name="new2"></icon>
                                </a>
                                <a :title="importChangeValidReason" @click="!importButtonToggleDisable && openImportAssetProjectModal()" v-show="filters.selectedTab === 'projects' && getRegnskabSystemKode()" :disabled="importButtonToggleDisable" class="button button-round flexbox-center no-label import-button">
                                    <icon class="medium-svg fill-primary" name="import"></icon>
                                </a>
                            </div>
                        </div>
                        <div class="large-8 cell dashboard-list">

                            <!-- list -->
                            <dashboard-projects-list v-show="filters.selectedTab === 'projects'" ref="projectList" v-model="projects" :kpi="KPIList" @removeKPIFilter="removeKPIFilter" @updateProjectList="setProjects" @export="exportProjects()"></dashboard-projects-list>
                            <dashboard-reports-list v-show="filters.selectedTab === 'reports'" :yearSelected="yearSelected" v-model="reports" @updateReportList="setReports"></dashboard-reports-list>
                            <dashboard-jobs-list v-show="filters.selectedTab === 'jobs'" v-model="jobs" @updateJobList="updateJobList"></dashboard-jobs-list>
                            <dashboard-assets-list v-show="filters.selectedTab === 'asset'" v-model="assets"></dashboard-assets-list>
                        </div>
                    </div>
                </div>
            </main>

        </div>
        <div v-else class="loading-div">
            <h1 class="loading-header">Danner dit overblik...</h1>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import axios from '@/store/api.js'
// components
import Modal from '@/components/modal/modal.vue'
import { ModalConfig } from '@/components/modal/modal.js'
import animatedNumber from '@/components/counter/animated-number.vue'
// dashboard components
import dashboardProjectsList from '@/components/page/dashboard/dashboard-projects-list.vue'
import dashboardReportsList from '@/components/page/dashboard/dashboard-reports-list.vue'
import dashboardJobsList from '@/components/page/dashboard/dashboard-jobs-list.vue'
import dashboardAssetsList from '@/components/page/dashboard/dashboard-assets-list.vue'

var VueCookie = require('vue-cookie')

export default {
    name: 'dashboard',
    components: {
        Modal,
        'date-picker': Datepicker,
        'animated-number': animatedNumber,
        'dashboard-projects-list': dashboardProjectsList,
        'dashboard-reports-list': dashboardReportsList,
        'dashboard-jobs-list': dashboardJobsList,
        'dashboard-assets-list': dashboardAssetsList
    },
    data () {
        return {
            loading: false,
            accountingTypeId: '',
            // modal create update job
            jobModalConfig: null,
            projectModalConfig: null,
            handlerModalConfig: null,
            handlerHeader: '',
            newProject: {},
            activeJobType: null,
            // importer projekt
            importProjectModalConfig: null,
            importChangeValidReason: 'Importér Asset ændringer til projekt',
            importButtonToggleDisable: false,
            // header
            tabs: [
                {name: 'projects'},
                {name: 'reports'},
                {name: 'jobs'}
            ],
            KPIList: [
                {filter: 'onGoing', count: 0, category: 'projects', selected: false, types: []},
                {filter: 'correction', count: 0, category: 'projects', selected: false, types: [4]}
            ],
            // filter
            projectSearchQueryActive: false,
            yearSelected: null,
            selectedReportBalance: null,
            // lists
            projects: [],
            reports: [],
            jobs: [],
            assets: [],
            // other
            regnskabListId: null,
            // asset filter
            finishedAsset: false,
            AfskrivningsDato: null
        }
    },
    computed: {
        ...mapGetters({
            filters: 'getFilters',
            codeLists: 'getCodelists',
            regnskabList: 'getRegnskabList',
            firstTimeLogIn: 'firstTimeLogIn',
            projectStatus: 'getProjectStatus',
            selectedBalance: 'getSelectedBalance',
            regnskabSetting: 'getRegnskabSetting',
            selectedRegnskab: 'getSelectedRegnskab',
            reportBalanceList: 'getReportBalanceList',
            selectedReportBalanceSetting: 'getSelectedReportBalanceSetting'
        }),
        filteredProjectStatus () {
            return this.projectStatus.filter(p => p.beskrivelse !== 'Sat til aktivering' && p.beskrivelse !== 'Værdisat')
        },
        years () {
            if (this.reportBalanceList.length > 0) {
                let foundBalance = this.reportBalanceList.find(b => b.id === this.selectedReportBalanceSetting.id)
                if (foundBalance) {
                    return foundBalance.aar.sort((a, b) => {
                        let keyA = a.aar
                        let keyB = b.aar

                        if (keyA < keyB) {
                            return -1
                        }
                        if (keyA > keyB) {
                            return 1
                        }
                        return 0
                    })
                }
            }
            return []
        },
        searchString: {
            get () {
                return this.filters.searchString
            },
            set (value) {
                this.$store.commit('setFilter', {
                    key: 'searchString',
                    value: value
                })
            }
        }
    },
    methods: {
        ...mapActions({
            setFilter: 'setFilter',
            setFirstTimeLogIn: 'setFirstTimeLogIn',
            setReportBalanceList: 'setReportBalanceList'
        }),
        changeWorkView (selectedView) {
            if (this.filters.selectedTab !== selectedView) {
                this.setFilter({
                    key: 'selectedTab',
                    value: selectedView
                })
            }
        },
        async changeBalanceType ($event) {
            try {
                let id = this.reportBalanceList[$event.target.selectedIndex - 1].id
                if (id) {
                    this.selectedReportBalance = id
                    this.$store.state.dashboard.selectedReportBalanceSetting = this.reportBalanceList[$event.target.selectedIndex - 1]
                }
            } catch (err) {
                console.log('error change balance type', err)
            }
        },
        selectYear ($event) {
            const selectedYear = this.years[$event.target.selectedIndex]
            if (selectedYear) {
                this.yearSelected = selectedYear.id
            }
        },
        async showKpiData (filter, category) {
            try {
                let selectedKPI = null
                this.KPIList.forEach(kpi => {
                    if (kpi.filter === filter) {
                        selectedKPI = kpi
                    } else {
                        kpi.selected = false
                    }
                })
                if (!selectedKPI.selected) {
                    this.setFilter({
                        key: 'selectedTab',
                        value: 'projects'
                    })
                    selectedKPI.selected = true
                    this.setFilter({
                        key: selectedKPI.filter,
                        value: true
                    })
                } else {
                    selectedKPI.selected = false
                    this.setFilter({
                        key: selectedKPI.filter,
                        value: true
                    })
                }

                await this.setProjects()
            } catch (err) {
                console.log('error getting kpi data from server', err)
            }
        },
        async removeKPIFilter (kpi) {
            try {
                this.KPIList.forEach(kpiItem => {
                    if (kpiItem.filter === kpi.filter) {
                        kpiItem.selected = false
                    }
                })

                await this.setProjects()
            } catch (err) {
                console.log('error removing kpi filter', err)
            }
        },
        async enter () {
            if (this.searchString) {
                if (this.searchString.length > 1) {
                    try {
                        await this.setProjects()
                    } catch (err) {
                        console.log('err search', err)
                    }
                }
            }
        },
        async searchInput () {
            if (this.searchString.length < 1) {
                try {
                    this.projectSearchQueryActive = false
                    await this.setProjects()
                } catch (err) {
                    console.log('searchInput err', err)
                }
            }
        },
        getProjectStatusIcon (beskrivelse) {
            const text = beskrivelse.toLowerCase()
            if (text === 'værdisat') {
                return 'imported'
            }
            if (text === 'aktiveret med fiktive aktiver') {
                return 'fiction'
            }
            if (text === 'sat til aktivering') {
                return 'help'
            }
            return text
        },
        createNewProject () {
            this.newProject = {}
            this.projectModalConfig.open()
        },
        newJobModal () {
            this.activeJobType = null
            this.jobModalConfig.open()
        },
        openImportAssetProjectModal () {
            this.importProjectModalConfig.open()
        },
        async importAssetProject () {
            this.importProjectModalConfig.close()
            try {
                this.handlerHeader = 'Importerer projekt...'
                this.handlerModalConfig.open()
                const response = await axios.post('/Value/Project/ImportProject', {
                    eksternId: '',
                    regnskabId: this.accountingTypeId
                })

                if (response) {
                    this.handlerModalConfig.close()

                    this.$router.push({
                        name: 'matchid',
                        params: {
                            id: response.data.id
                        }
                    })
                }
            } catch (err) {
                console.log('error importing asset project', err)
                this.handlerModalConfig.close()
            }
        },
        setActiveJobType (kode, valid) {
            if (valid === 1) {
                this.activeJobType = kode
            }
        },
        async createJob () {
            try {
                const response = await axios.post('/Value/Job/CreateJob', {
                    jobTypeKode: this.activeJobType,
                    regnskabId: this.accountingTypeId
                })
                if (response) {
                    this.setJobs()
                }
            } catch (err) {
                console.log('error creating job', err)
            }
        },
        async createProject () {
            if (this.newProject.projectNr !== '' && this.newProject.projectNr !== undefined) {
                try {
                    this.handlerHeader = 'Opretter projekt'
                    this.handlerModalConfig.open()
                    this.newProject.regnskabId = this.accountingTypeId
                    const response = await axios.post('/Value/Project/CreateProject', this.newProject)
                    if (response) {
                        await this.setProjects()
                        this.handlerModalConfig.close()
                    }
                } catch (err) {
                    this.handlerHeader = 'Der skete en fejl'
                    setTimeout(() => {
                        this.handlerModalConfig.close()
                    }, 2500)
                    console.log('error creating project', err)
                }
            } else {
                this.handlerHeader = 'Projektnummer påkrævet'
                this.handlerModalConfig.open()
                setTimeout(() => {
                    this.handlerModalConfig.close()
                }, 2500)
            }
        },
        async setProjects () {
            if (this.$refs.projectList) {
                this.$refs.projectList.currentPage = 1
            }

            // let projectTypes = []
            // this.KPIList.forEach(kpi => {
            //     if (kpi.selected) {
            //         projectTypes = kpi.types
            //     }
            // })

            try {
                const response = await axios.post('/Value/Project/ReadProjectList', {
                    regnskabsId: this.accountingTypeId,
                    projectStatus: this.filters.onGoing ? [2, 3, 4] : this.filters.projectStatusCodes,
                    searchQuery: this.searchString ? this.searchString : '',
                    projectType: null
                })
                if (response) {
                    this.projects = response.data

                    if (this.selectedRegnskab.systemKode === 4) {
                        if (this.projects.some(p => p.projektStatusKode < 4 && p.projektTypeKode === 999)) {
                            this.importButtonToggleDisable = true
                            const importProjectChange = await axios.post('/Value/Asset/ImportProjectChange', {
                                id: this.accountingTypeId
                            })
                            this.importChangeValidReason = importProjectChange.data.importChangeValidReason
                        } else {
                            this.importButtonToggleDisable = false
                            this.importChangeValidReason = 'Importér Asset ændringer til projekt'
                        }
                    }
                }
            } catch (err) {
                throw err
            }
        },
        async setReports () {
            try {
                const response = await axios.post('/Value/Report/GetReportList', {
                    regnskabId: this.accountingTypeId
                })
                if (response) {
                    this.reports = response.data
                }
            } catch (err) {
                throw err
            }
        },
        async setJobs () {
            try {
                const response = await axios.post('/Value/Job/ReadJob', {
                    regnskabId: this.accountingTypeId
                })
                if (response) {
                    this.jobs = response.data
                }
            } catch (err) {
                throw err
            }
        },
        updateJobList (job) {
            const index = this.jobs.indexOf(job)
            if (index > -1) {
                this.jobs.splice(index, 1)
            }
        },
        async setAssets () {
            try {
                const response = await axios.post('/Value/Asset/EmneAendringRead', {
                    regnskabId: this.accountingTypeId,
                    includingFinnished: this.finishedAsset === false ? 0 : 1
                })
                if (response) {
                    if (response.data.length > 0) {
                        response.data.forEach(res => {
                            res.checked = false
                        })
                    }
                    this.assets = response.data
                }
            } catch (err) {
                console.log('error getting assets', err)
            }
        },
        async handleDepreciation () {
            try {
                let promises = []
                let errors = 0
                let date = new Date(this.AfskrivningsDato)
                let afskrivDato = date.getFullYear() + '-' +
                (date.getMonth() + 1) + '-' +
                date.getDate()
                this.assets.forEach(asset => {
                    if (asset.checked) {
                        promises.push(axios.post('/Value/Asset/EmneAendringFinish', {
                            emneAendringId: asset.id,
                            emneAendringDato: afskrivDato
                        }).then((res) => {
                            if (res.data) {
                                asset.checked = false
                                asset.behandlingsDato = new Date()
                            }
                        }).catch(() => errors++))
                    }
                })

                if (promises.length > 0) {
                    this.handlerHeader = `Afskriver dato for ${promises.length} assets`
                    this.handlerModalConfig.open()
                    await Promise.all(promises).then(() => console.log(errors))
                    await this.setAssets()
                    this.handlerModalConfig.close()
                }
            } catch (err) {
                this.handlerHeader = 'Der skete en fejl under afskrivning af assets'
                setTimeout(() => {
                    this.handlerModalConfig.close()
                }, 2500)
                console.error('error handle depreciation', err)
            }
        },
        setFinishedAsset () {
            this.finishedAsset = !this.finishedAsset
            this.setAssets()
        },
        async setProjectStatusCodes (kode) {
            if (!kode) {
                let codeArray = []
                this.projectStatus.forEach(status => codeArray.push(status.kode))
                this.setFilter({
                    key: 'projectStatusCodes',
                    value: codeArray
                })
            } else {
                let index = this.filters.projectStatusCodes.indexOf(kode)
                if (index > -1) {
                    this.setFilter({
                        key: 'projectStatusCodes',
                        value: index,
                        handler: 'splice'
                    })
                } else {
                    this.setFilter({
                        key: 'projectStatusCodes',
                        value: kode,
                        handler: 'push'
                    })
                }

                try {
                    await this.setProjects()
                } catch (err) {
                    console.log('error setting projects', err)
                }
            }
        },
        getRegnskabSystemKode () {
            const selectedRegnskabFromList = this.regnskabList(this.regnskabListId)
            if (selectedRegnskabFromList) {
                return selectedRegnskabFromList.systemKode !== 1
            }
            return false
        },
        async exportProjects () {
            try {
                const response = await axios.downloadExcel('/Value/Export/ExportProjektListe', {
                    regnskabsId: this.accountingTypeId,
                    projectStatus: this.filters.onGoing ? [2, 3, 4] : this.filters.projectStatusCodes,
                    searchQuery: this.searchString ? this.searchString : '',
                    projectType: null
                })
                if (response) {
                    return new Promise((resolve, reject) => {
                        let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })

                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, 'Projekter.xlsx')
                            resolve(blob)
                        }

                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob, 'Projekter.xlsx')
                        link.download = 'Projekter.xlsx'
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)

                        resolve(blob)
                    })
                }
            } catch (err) {
                throw err
            }
        }
    },
    watch: {
        selectedReportBalanceSetting (val, oldVal) {
            if (val.id !== oldVal.id) {
                this.yearSelected = this.years[this.years.length - 1].id
            }
        },
        activeJobType (val) {
            if (val) {
                this.jobModalConfig.buttons.find(b => b.action === 'accept').disabled = false
            } else {
                this.jobModalConfig.buttons.find(b => b.action === 'accept').disabled = true
            }
        }
    },
    async created () {
        try {
            this.loading = true
            if (this.selectedRegnskab.id) {
                this.accountingTypeId = this.selectedRegnskab.id
            } else {
                this.accountingTypeId = this.selectedRegnskab
            }

            this.regnskabListId = VueCookie.get('selectedRegnskab')
            this.KPIList.forEach(kpi => {
                if (kpi.filter === 'onGoing') {
                    kpi.selected = this.filters.onGoing
                }
                if (kpi.filter === 'correction') {
                    kpi.selected = this.filters.correction
                }
            })

            if (this.reportBalanceList.length === 0) {
                await this.setReportBalanceList()
            }

            // if first time login
            if (this.firstTimeLogIn) {
                await this.setProjectStatusCodes()
                this.setFirstTimeLogIn(false)
            }
            await this.setProjects()
            await this.setReports()
            await this.setJobs()

            if (this.getRegnskabSystemKode()) {
                this.tabs.push({name: 'asset'})
                await this.setAssets()
            }

            const currentBalanceYear = this.regnskabSetting.find(r => r.id === this.selectedBalance.id)
            if (currentBalanceYear) {
                this.AfskrivningsDato = new Date(currentBalanceYear.aarsbalance.aar, 11, 31)
            }

            this.selectedReportBalance = this.selectedReportBalanceSetting.id
            this.yearSelected = this.years[this.years.length - 1].id

            this.importProjectModalConfig = new ModalConfig({
                reject: 'Annuller',
                accept: 'Importer projekt'
            })
            this.jobModalConfig = new ModalConfig({
                disabled: true,
                reject: 'Annuller',
                accept: 'Opret'
            })
            this.projectModalConfig = new ModalConfig({
                reject: 'Annuller',
                accept: 'Opret'
            })

            this.handlerModalConfig = new ModalConfig({})

            this.loading = false
        } catch (err) {
            console.log('error created dashboard', err)
            this.loading = false
        }
    }
}
</script>

<style lang="scss">
.loading-div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;

    & .loading-header {
        font-size: 2rem;
    }
}

.form {
    margin-top: 10px;
    margin-bottom: 10px;

    .form-item {
        border-radius: 3px;
        height: 185px;
        position: relative;
        margin-left: 10px;
        margin-right: 10px;
        border: 2px solid transparent;
        box-shadow: 0 5px 10px 4px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24);
        transform: scale(.95);
        cursor: pointer;
        transition: transform .3s ease;

        &:hover:not(.form-item-disabled), &:active:not(.form-item-disabled), &:focus:not(.form-item-disabled) {
            transform: scale(1) !important;
            box-shadow: 5px 20px 30px rgba(0,0,0,.2) !important;
            border-color: #5293bc !important;
        }

        &.selected {
            transform: scale(1) !important;
            box-shadow: 5px 20px 30px rgba(0,0,0,.2) !important;
            border-color: #5293bc !important;
        }

        &.form-item-disabled {
            background-color: #ddd;
            cursor: not-allowed;
            color: #aaa;
        }

        .flex-center {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            padding: 10px;
            text-align: center;
        }

        .checkmark-checked {
            width: 45px;
            height: 45px;
            border-radius: 50%;
            background-color: #5293bc;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            align-items: center;
            justify-content: center;
            right: -22px;
            position: absolute;
            bottom: -11px;
        }

        p {
            font-weight: bold;
            font-size: 1.1rem;
            margin-bottom: 0px;
        }

        .form-item-warning {
            font-size: 0.8rem;
            color: rgba(240, 0, 0, 1);
            margin-top: 5px;
        }
    }
}

.form {
  .border-bottom {
    border-bottom: 1px solid #efeded;
    padding-top: 15px;
    padding-bottom: 15px;
    position: relative;

    input {
        width: 100%;
    }
  }

  .border-bottom-last {
    border-bottom: 0px !important;
  }
}

.list-sort .non-sortable {
    cursor: initial;

    &:hover, &:focus, &:active {
        text-decoration: none;
    }
}

.modal-body p {
    margin-bottom: 0px;
}

.required {
    color: red;
}

.filter-closed {
    text-transform: capitalize;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin-right: 12px;
    margin-left: 15px;
    cursor: pointer;

    & div {
        width: 35px;
        height: 35px;
        background: #bebebe;
        margin-right: 10px;
        border-radius: 3px;
        border: 3px solid #bebebe;

        &.active {
            border-color: #666;
            background: #666;
        }
    }

    & span {
        margin-right: 10px;
        margin-top: 5px;
    }
}

.checkbox-end {
    margin-left: 20px;
}

.import-button {
    &[disabled] {
        // pointer-events: none;

        svg {
            fill: white !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard.vue